module.exports = __webpack_public_path__ + "media/radiance3.2d24b27a.webm";